<template>
  <BaseModal @close="close">
    <h2 slot="header">{{lang.title}}</h2>
    <div slot="body" :id="id" style="text-align: center"></div>
  </BaseModal>
</template>

<script>
import BaseModal from './BaseModal.vue'
export default {
  components: {
    BaseModal
  },
  props: {
    lang: {
      type: Object,
      default () {
        return {
          title: 'qrcode'
        }
      }
    }
  },
  data () {
    return {
      id: 'modal-qrcode',
      /**
       * @see https://github.com/kazuhikoarase/qrcode-generator/tree/master/js
       */
      qr: null,
      typeNumber: 0, // 0 === auto detect
      errorCorrectionLevel: 'M',
      cellSize: 1,
      margin: 0
    }
  },
  computed: {
    url () {
      return location.href
    }
  },
  mounted () {
    this.qr = window.qrcode(this.typeNumber, this.errorCorrectionLevel)
    this.qr.addData(this.url)
    this.qr.make()
    document.getElementById(this.id).innerHTML = this.qr.createSvgTag(this.cellSize, this.margin)
  },
  methods: {
    close () { this.$emit('close') }
  }
}
</script>

<style lang="postcss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/modal/QrcodeModal.vue